import React from "react";
import { FiX } from "react-icons/fi"; // Importing Close (X) icon

function ProjectMedia({ formData, handleFileChange, handleRemoveFile }) {
  return (
    <fieldset className="border border-gray-300 p-4 rounded-md">
      <legend className="text-lg font-semibold px-2">Project Media</legend>
      <div className="grid grid-cols-1 gap-4">
        
        {/* Project Pictures */}
        <div>
          <label className="block text-gray-700 font-medium">Project Pictures</label>
          <input
            type="file"
            name="projectPictures"
            multiple
            accept="image/*"
            onChange={(e) => handleFileChange(e, "projectPictures")}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          />
          {formData?.media?.projectPictures?.length > 0 && (
            <div className="mt-2 flex flex-wrap gap-2">
              {formData.media.projectPictures.map((file, index) => (
                <div key={index} className="relative">
                  <img
                    src={URL.createObjectURL(file)}
                    alt={`Project ${index + 1}`}
                    className="w-20 h-20 object-cover rounded-md border"
                  />
                  {/* Remove Button */}
                  <button
                    type="button"
                    onClick={() => handleRemoveFile("projectPictures", index)}
                    className="absolute top-0 right-0 bg-red-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"
                  >
                    <FiX className="text-white w-4 h-4" />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Upload Brochure */}
        <div>
          <label className="block text-gray-700 font-medium">Upload Brochure (PDF)</label>
          <input
            type="file"
            name="brochure"
            accept="application/pdf"
            onChange={(e) => handleFileChange(e, "brochure")}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          />
          {formData?.media?.brochure && (
            <div className="mt-2 flex items-center gap-2">
              <p className="text-sm text-gray-600">Uploaded: {formData.media.brochure.name}</p>
              <button
                type="button"
                onClick={() => handleRemoveFile("brochure")}
                className="bg-red-600 text-white px-2 py-1 text-xs rounded flex items-center gap-1"
              >
                <FiX className="text-white w-4 h-4" /> Remove
              </button>
            </div>
          )}
        </div>

        {/* Project Map */}
        <div>
          <label className="block text-gray-700 font-medium">Project Map</label>
          <input
            type="file"
            name="projectMap"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "projectMap")}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          />
          {formData?.media?.projectMap && (
            <div className="mt-2 relative">
              <img
                src={URL.createObjectURL(formData.media.projectMap)}
                alt="Project Map"
                className="w-40 h-40 object-cover rounded-md border"
              />
              {/* Remove Button */}
              <button
                type="button"
                onClick={() => handleRemoveFile("projectMap")}
                className="absolute top-0 right-0 bg-red-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"
              >
                <FiX className="text-white w-4 h-4" />
              </button>
            </div>
          )}
        </div>

          {/* ✅ New: Project Logos Upload */}
          <div>
          <label className="block text-gray-700 font-medium">Project Logos</label>
          <input
            type="file"
            name="projectLogos"
            multiple
            accept="image/*"
            onChange={(e) => handleFileChange(e, "projectLogos")}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          />
          {formData?.media?.projectLogos?.length > 0 && (
            <div className="mt-2 flex flex-wrap gap-2">
              {formData.media.projectLogos.map((file, index) => (
                <div key={index} className="relative">
                  <img
                    src={URL.createObjectURL(file)}
                    alt={`Logo ${index + 1}`}
                    className="w-20 h-20 object-cover rounded-md border"
                  />
                  <button
                    type="button"
                    onClick={() => handleRemoveFile("projectLogos", index)}
                    className="absolute top-0 right-0 bg-red-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"
                  >
                    <FiX className="text-white w-4 h-4" />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

      </div>
    </fieldset>
  );
}

export default ProjectMedia;
